const buildPieChartStyles = (variant: string, chartValue: number) => {
  const boxSize = variant === "primary" ? "160px" : "80px";
  const radialGradientStyles = "radial-gradient(circle, white 0, white 30%, transparent 30%, transparent 70%, white 0)";
  const conicGradientStyles = `conic-gradient(from 0, success.600 ${chartValue}%, success.200 ${chartValue}%)`;

  return {
    boxSize,
    bgGradient: `${radialGradientStyles},${conicGradientStyles}`,
  };
};

export default buildPieChartStyles;
